import {Button, DialogTitle, Zoom} from "@mui/material";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import React, {useState} from "react";
import {observer} from "mobx-react";
import {useStores} from "../../../../Hooks";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import ConditionalComponent from "../../../Shared/ConditionalComponent";
import CircularProgress from '@mui/material/CircularProgress'
import {GeneralRequester} from "../../../../MobxStores/RequestApi/GeneralRequester";
import {ReportSentDialog} from "./ReportSentDialog";

export const typeOfError = {
    SOMETHING_WENT_WRONG: 'SWW',
    CONNECTION_ERROR: 'CE',
    TRY_AGAIN_SOON: 'TAS',
    INVALID_API: 'IA',
    LIMIT_EXCEEDED: 'LE',
    INCOMPLETE_TRANSLATION: 'IT',
    CANCEL_TRANSLATION: 'CT'
}
export const TranslationErrorDialog = observer(({props}) => {
    const {editorStore, generalStore} = useStores();
    const {downloadCurrentLanguages, isReportSuccessOpen, setIsReportSuccessOpen} = props
    const [isLoading, setIsLoading] = useState(false)

    const handleConfirm = () => {
        editorStore.isTranslationErrorDialogOpen = false
        editorStore.isTranslationProgressDialogOpen = true
    }

    const cancelTranslation = () => {
        editorStore.isTranslationErrorDialogOpen = false
        editorStore.cancelTranslation = true

    }

    const rotateToHelpCenter = () => {
        window.open('https://helpdesk.frontline.io/', '_blank')
    }

    const reportTheIssue = async () => {
        setIsLoading(true)
        const error = getHeader()
        await GeneralRequester.sendWebLogs(generalStore.workspace, error, editorStore.errorInfo)
        setIsLoading(false)
        editorStore.isTranslationErrorDialogOpen = false
        setIsReportSuccessOpen(true)
    }

    const downloadLanguages = () => {
        editorStore.isTranslationErrorDialogOpen = false
        downloadCurrentLanguages()
    }

    const getHeader = () => {
        switch (editorStore.errorType) {
            case typeOfError.CONNECTION_ERROR:
                return 'Connection error'
            case typeOfError.SOMETHING_WENT_WRONG:
                return 'Something went wrong'
            case typeOfError.INVALID_API:
                return 'Invalid API'
            case typeOfError.LIMIT_EXCEEDED:
                return 'AI Usage Limit Reached'
            case typeOfError.INCOMPLETE_TRANSLATION:
                return 'Incomplete translation'
            case typeOfError.TRY_AGAIN_SOON:
                return 'Try again soon'
            case typeOfError.CANCEL_TRANSLATION:
                return 'Cancel translation'
            default:
                return 'Something went wrong'
        }
    }

    const getBodeText = () => {
        switch (editorStore.errorType) {
            case typeOfError.CONNECTION_ERROR:
                return (
                    <>
                        <div><span className='popup-text'>
                        {'We encountered an connection issue. Make sure you have'}
                    </span></div>
                        <div><span className='popup-text'>
                        {'internet connection and try again.'}
                    </span></div>
                    </>)
            case typeOfError.SOMETHING_WENT_WRONG:
                return (
                    <>
                        <div><span className='popup-text'>
                        {'We encountered an issue translating the flow. Please try again'}
                    </span></div>
                        <div><span className='popup-text'>
                        {'in a couple of minutes.'}
                    </span></div>
                    </>)
            case typeOfError.INVALID_API:
                return (
                    <div><span className='popup-text'>
                        {'Please contact your workspace administrator to fix the issue.'}
                    </span></div>)
            case typeOfError.LIMIT_EXCEEDED:
                return (
                    <>
                        <div><span className='popup-text'>
                        {'Your workspace has reached its AI credit limit. To continue translating with AI, contact your administrator to increase the credit allocation.'}
                    </span></div>
                    </>)
            case typeOfError.INCOMPLETE_TRANSLATION:
                return (
                    <div><span className='popup-text'>
                        {'Translations returned incomplete. Please try again.'}
                    </span></div>)
            case typeOfError.TRY_AGAIN_SOON:
                return (
                    <>
                        <div><span className='popup-text'>
                        {'Sorry...The translation service is currently unavailable. Please'}
                    </span></div>
                        <div><span className='popup-text'>
                        {'try again in a couple of minutes.'}
                    </span></div>
                    </>)
            case typeOfError.CANCEL_TRANSLATION:
                return (
                    <>
                        <div><span className='popup-text'>
                        {'Are you sure you want to cancel the translation process?'}
                    </span></div>
                        <div><span className='popup-text'>
                        {'No translations will be inserted.'}
                    </span></div>
                    </>)
            default:
                return (
                    <>
                        <div><span className='popup-text'>
                        {'We encountered an connection issue. Make sure you have '}
                    </span></div>
                        <div><span className='popup-text'>
                        {'internet connection and try again.'}
                    </span></div>
                    </>)
        }
    }

    const getButtons = () => {
        switch (editorStore.errorType) {
            case typeOfError.CONNECTION_ERROR:
                return (<>
                    <Button className='retry-button' variant="contained"
                            onClick={handleConfirm}>
                        {'Retry'}
                    </Button>
                </>)
            case typeOfError.SOMETHING_WENT_WRONG:
                return (<>
                    <Button
                        className='try-later-button'
                        variant="outlined"
                        onClick={() => editorStore.isTranslationErrorDialogOpen = false}>
                        {'I\'ll try again later'}
                    </Button>
                    <Button className='retry-button' variant="contained"
                            onClick={handleConfirm}>
                        {'Retry now'}
                    </Button>
                </>)
            case typeOfError.INVALID_API:
                return (<>
                    <Button className='retry-button' variant="contained"
                            onClick={() => editorStore.isTranslationErrorDialogOpen = false}>
                        {'OK'}
                    </Button>
                </>)
            case typeOfError.LIMIT_EXCEEDED:
                return (<>
                    <Button className='retry-button' variant="contained"
                            onClick={() => editorStore.isTranslationErrorDialogOpen = false}>
                        {'OK'}
                    </Button>
                </>)
            case typeOfError.INCOMPLETE_TRANSLATION:
                return (<>
                    <Button className='retry-button' variant="contained"
                            onClick={handleConfirm}>
                        {'Retry'}
                    </Button>
                </>)
            case typeOfError.TRY_AGAIN_SOON:
                return (<>
                    <Button className='retry-button' variant="contained"
                            onClick={() => editorStore.isTranslationErrorDialogOpen = false}>
                        {'OK'}
                    </Button>
                </>)
            case typeOfError.CANCEL_TRANSLATION:
                return (<>
                    <Button
                        className='try-later-button'
                        variant="outlined"
                        onClick={() => editorStore.isTranslationErrorDialogOpen = false}>
                        {'Continue translating'}
                    </Button>
                    <Button className='retry-button' variant="contained"
                            onClick={cancelTranslation}>
                        {'Cancel translation'}
                    </Button>
                </>)
            default:
                return (<>
                    <Button className='retry-button' variant="contained"
                            onClick={handleConfirm}>
                        {'Retry'}
                    </Button>
                </>)
        }
    }

    if (isLoading) {
        return (
            <Dialog
                open={editorStore.isTranslationErrorDialogOpen}
                onClose={() => editorStore.isTranslationErrorDialogOpen = false}
                className='translate-popup'
                TransitionComponent={Zoom}
            >
                <DialogContent className='container-loading'>
                    <CircularProgress className='container-loader' size={200}/>
                </DialogContent>
            </Dialog>
        )
    }

    return (
        <Dialog
            open={editorStore.isTranslationErrorDialogOpen}
            onClose={() => editorStore.isTranslationErrorDialogOpen = false}
            className='translate-popup'
            TransitionComponent={Zoom}
        >
            <DialogTitle className='popup-header'>
                <WarningAmberIcon className='delete-language-icon'/>
                <div>
                    <div>{getHeader()}</div>
                    {editorStore.errorType === typeOfError.LIMIT_EXCEEDED && editorStore.errorInfo?.maxAiRequests && (
                        <div className='popup-text' style={{fontSize: '13px', color: 'gray'}}>
                            {`${editorStore.errorInfo.currentAiRequestsCount?.toLocaleString()} / ${editorStore.errorInfo.maxAiRequests?.toLocaleString()} credits used`}
                        </div>
                    )}
                </div>
            </DialogTitle>
            <DialogContent>
                <DialogContentText style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center'
                }}>
                    {getBodeText()}

                    <ConditionalComponent if={editorStore.errorType !== typeOfError.LIMIT_EXCEEDED && editorStore.errorType !== typeOfError.CANCEL_TRANSLATION}>
                        <div style={{
                            marginTop: '10px',
                        }}> <span
                            className='popup-text'>{'If the problem persists '}</span>
                            <span
                                className='popup-text bold link'
                                onClick={reportTheIssue}
                            >
                            {'let us know'}
                        </span>
                        </div>
                    </ConditionalComponent>

                    <ConditionalComponent if={editorStore.errorType === typeOfError.LIMIT_EXCEEDED}>
                        <div style={{
                            marginTop: '10px',
                        }}> <span
                            className='popup-text'>{'For more information about this visit our '}</span>
                            <span
                                className='popup-text bold link'
                                onClick={rotateToHelpCenter}
                            >
                            {'help center'}
                        </span>
                        </div>
                    </ConditionalComponent>
                </DialogContentText>
            </DialogContent>
            <DialogActions className='footer-buttons'>
                {getButtons()}
            </DialogActions>
            <ConditionalComponent if={editorStore.errorType === typeOfError.INCOMPLETE_TRANSLATION}>
                <DialogActions className='footer-buttons'>
                    <Button
                        style={{marginTop: '-20px'}}
                        className='try-later-button'
                        variant="outlined"
                        onClick={downloadLanguages}>
                        {'Keep like this and download to CSV'}
                    </Button>
                </DialogActions>
            </ConditionalComponent>
            <ReportSentDialog isOpen={isReportSuccessOpen} setIsOpen={setIsReportSuccessOpen}/>
        </Dialog>
    )
})